import {
    Condition,
    BooleanCondition,
    BooleanConditionType,
    BooleanOperator,
} from "@tenforce/product-fields"
import { FilterParser } from "./index"
import { ConditionDTO } from "../../models/dto/conditions"
import { BooleanConditionDTO } from "../../models/dto/conditions/BooleanCondition"

export const BooleanConditionDTOType = "#TF.BooleanFieldCondition"
export enum BooleanOperatorDTO {
    IsEqualTo = "IsEqualTo",
}

const checkIfApplicable = (condition: Condition): boolean => {
    return condition?.type === BooleanConditionType
}
const checkIfApplicableDTO = (condition: ConditionDTO): boolean => {
    return condition["@type"] === BooleanConditionDTOType
}

const parseFromDTO = (condition: BooleanConditionDTO): BooleanCondition => {
    if (!checkIfApplicableDTO(condition)) {
        return null
    }
    let result: BooleanCondition = null
    switch (condition.Operator) {
        case BooleanOperatorDTO.IsEqualTo: {
            result = {
                type: BooleanConditionType,
                operator: BooleanOperator.IsEqualTo,
                isLocked: condition.IsLocked,
                value: condition.Value,
            }
            break
        }
        default:
            break
    }
    return result
}

const parseToDTO = (
    id: string,
    condition: BooleanCondition,
): BooleanConditionDTO | null => {
    if (!condition || !checkIfApplicable(condition)) {
        return null
    }
    let result: BooleanConditionDTO | null = null
    switch (condition.operator) {
        case BooleanOperator.IsEqualTo: {
            result = {
                "@type": BooleanConditionDTOType,
                Operator: BooleanOperatorDTO.IsEqualTo,
                Value: condition.value,
                IsLocked: condition.isLocked,
                FieldDefinition: {
                    Id: id,
                },
            }
            break
        }
        default:
            break
    }
    return result
}

const parser: FilterParser = {
    Type: BooleanConditionType,
    TypeDTO: BooleanConditionDTOType,
    checkIfApplicable,
    checkIfApplicableDTO,
    parseFromDTO,
    parseToDTO,
}
export default parser
